// Données complètes - Gail Lleyton Production Musicale - VERSION FINALE

export const artistInfo = {
  name: "Gail Lleyton",
  tagline: "Artiste • Productrice • Beatmaker",
  bio: "Artiste polyvalente, je fusionne production musicale, beatmaking et direction artistique pour créer des univers sonores uniques. De la composition à la réalisation, j'accompagne artistes et projets avec créativité et expertise technique.",
  image: "/media/hero-bg.png",
  heroBackground: "/media/youtube-studio.jpg",
  social: {
    spotify: "https://open.spotify.com/artist/6y1ifttLAOALmi7aPZtWcP",
    soundcloud: "https://soundcloud.com/GailLleyton",
    youtube: "https://www.youtube.com/c/gaillleyton?sub_confirmation=1",
    appleMusic: "https://music.apple.com/fr/artist/gail-lleyton/532737218",
    instagram: "https://www.instagram.com/GailLleyton",
    tiktok: "https://www.tiktok.com/@gaillleyton",
    linktree: "https://linktr.ee/GailLleyton",
  }
};

export const discography = [
  {
    id: 1,
    title: "Viens avec moi (Ben G Ft DJ Ash K)",
    year: 2025,
    type: "Single",
    cover: "https://hypeddit-gates-prod.s3.amazonaws.com/xqjsc6_coverartmanual",
    streamUrl: "https://open.spotify.com/intl-fr/track/5I7QxbP3EDzKaTuflXFWzh",
    youtubeUrl: "https://youtu.be/Mv1fck0u8JI?si=qwSovxJyCiiww0Kg",
    description: "Une invitation douce et romantique sur fond de Zouk moderne, entre tendresse et escapade sentimentale. **Gail Lleyton est choriste sur ce titre.**",
  },
  {
    id: 2,
    title: "Plus fort que moi (Anthow)",
    year: 2025,
    type: "Single",
    cover: "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/5c/08/d5/5c08d57f-864b-a111-65d8-67d5e6cbacc6/859717210475_cover.jpg/1200x630bb.jpg",
    streamUrl: "https://open.spotify.com/intl-fr/track/5rys1qmeubT8fMolrbrGPC",
    description: "Un titre envoûtant, un cri du cœur d'Anthow face à une passion incontrôlable, entre vulnérabilité et tension émotionnelle. **Gail Lleyton est à la composition et choriste sur ce titre.**",
  },
  {
    id: 3,
    title: "Projecteurs (Stony)",
    year: 2024,
    type: "Single",
    cover: "https://i.scdn.co/image/ab67616d0000b27353b91311d00b7e9c18db5de4",
    streamUrl: "https://open.spotify.com/intl-fr/track/71hpwv9B7Ncwfw6BrZN2nE",
    youtubeUrl: "https://youtu.be/f1Lbnp4gY-c?si=FQwOADJpP1jxuHgs",
    description: "RnB caribbéen et sensible, où Stony choisit l'amour discret loin des regards indiscrets. **Co-composition de Gail Lleyton Beats.**",
  },
  {
    id: 4,
    title: "La la land (FT Lisandro Cuxi)",
    year: 2024,
    type: "Single",
    cover: "https://i.scdn.co/image/ab67616d00001e02e42b2590bceb98851f077998",
    streamUrl: "https://open.spotify.com/intl-fr/track/0a3iTn9A7t5rUODNNeT4cW",
    youtubeUrl: "https://youtu.be/qF_EbiLDr2g?si=nGtS2Sfpe4atdOtB",
    embedUrl: "https://open.spotify.com/embed/track/0a3iTn9A7t5rUODNNeT4cW",
    description: "Remix envoûtant aux sonorités contemporaines Zouk/Kompa, pour une touche d'amour et de romantisme. **Composition de Gail Lleyton Beats.**",
  },
  {
    id: 5,
    title: "Faya (Ft Sosey)",
    year: 2024,
    type: "Single",
    cover: "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/db/4f/6e/db4f6ed4-ece4-236c-325c-bbbd106d02f9/859782304055_cover.jpg/600x600bf-60.jpg",
    streamUrl: "https://open.spotify.com/intl-fr/track/1CT549sZYx9XK0GOvI9npQ",
    youtubeUrl: "https://youtu.be/tqvwPx892bE?si=UWy235RirZooPHIb",
    description: "Remix avec un groove solaire et une fusion afro aux influences caribéennes Zouk/Kompa. **Composition de Gail Lleyton Beats.**",
  },
  {
    id: 6,
    title: "Baby Hello ! (Natwal)",
    year: 2024,
    type: "Single",
    cover: "/media/natwal-baby-hello-cover.jpg",
    streamUrl: "https://open.spotify.com/intl-fr/track/0SIeRCZgPvdwFQAWE6pZLR",
    youtubeUrl: "https://youtu.be/BEXbFfeG1fY?si=a3ZCKzkLqqCjQDf9",
    description: "Un titre vibrant et solaire, une histoire d'amour entre tendresse et mystère, porté par des sonorités afro-caribéennes. **Composition de Gail Lleyton Beats.**",
  },
  {
    id: 7,
    title: "Boom Bang (FT it's Jus)",
    year: 2024,
    type: "Single",
    cover: "https://i.scdn.co/image/ab67616d0000b273df6b30bfbbd6a49c43b5770c",
    streamUrl: "https://open.spotify.com/intl-fr/track/4zQenJesz6YkKG1Mi3JoOw",
    youtubeUrl: "https://youtu.be/-AJc6eF1Oo0?si=lFhqsnLyoLzogTCm",
    description: "Remix explosif avec une fusion rythmique envoûtante, mêlant beats urbains et vibrations modernes Zouk/Kompa. **Composition de Gail Lleyton Beats.**",
  },
  {
    id: 8,
    title: "Tempo (Gail Lleyton)",
    year: 2018,
    type: "Single",
    cover: "https://i.scdn.co/image/ab67616d00001e028a9b4062e3392de43c4ab22c",
    streamUrl: "https://open.spotify.com/intl-fr/album/7fmoU9DWRPYQULPAyR0uQ8",
    youtubeUrl: "https://youtu.be/CC0sJtr5Ggw?si=0ZOPBmlV-naJ5TXI",
    description: "Titre explorant les rythmes et cadences caribbéennes. **Composition de Gail Lleyton Beats.**",
  },
  {
    id: 9,
    title: "Crazy (Gail Lleyton)",
    year: 2017,
    type: "Single",
    cover: "https://i.scdn.co/image/ab67616d00001e027c7ead3e73d0cbe64cbf74a3",
    streamUrl: "https://open.spotify.com/intl-fr/track/3ZdJ6wQsFqVckellBnqha9",
    youtubeUrl: "https://youtu.be/J4UTuohIlyg?si=6mJcM7_r2-VMhtbc",
    description: "RnB intense, suave et émotionnel, où sensualité et séduction s'entrelacent.",
  },
  {
    id: 10,
    title: "Mon frère (Yoan ft Marvin)",
    year: 2015,
    type: "Single",
    cover: "https://i1.sndcdn.com/artworks-p7Bzop2vBSFk-0-t500x500.jpg",
    streamUrl: "https://open.spotify.com/intl-fr/track/1Y1AQRFqcQzHaIah8CwLUH",
    youtubeUrl: "https://youtu.be/j1LFgp7pFMQ?si=4dd72szfpWmQFV1B",
    description: "Un hommage vibrant à l'amitié fraternelle, entre loyauté et épreuves partagées. **Co-composition de Gail Lleyton Beats.**",
  },
  {
    id: 11,
    title: "Let Me Be the One (Gail Lleyton)",
    year: 2013,
    type: "Single",
    cover: "https://i.scdn.co/image/ab67616d00001e02685b4534dddce35bebd5468c",
    streamUrl: "https://open.spotify.com/intl-fr/track/2yY8CESIOQSYJIbjIQseQj",
    youtubeUrl: "https://youtu.be/5hND4AkAg_0?si=Cw7L4aELRFITTmoF",
    description: "RnB Old school, délicat et envoûtant, porté par des mélodies sensuelles.",
  },
  {
    id: 11,
    title: "I Wanna Be an Insomniac (Gail Lleyton)",
    year: 2012,
    type: "Single",
    cover: "/media/disco-i-wanna-be-insomniac.jpg",
    streamUrl: "https://www.youtube.com/watch?v=PRFAXjIc8rk",
    description: "Dance track électro-pop au rythme obsédant, pour une insomnie entre tension nocturne, désir lancinant et pulsation entêtante.",
  }
];

export const audioPortfolio = [
  {
    id: 1,
    title: "SUNSET TYPEBEAT",
    genre: "Afrobeat / Pop / Tropical",
    bpm: 53,
    key: "A minor",
    duration: "3:24",
    cover: "/media/sunset-typebeat-cover.png",
    audioFile: "/media/beats/sunset-typebeat.mp3",
    audioUrl: "https://soundcloud.com/gaillleyton/sunset-demo/s-YYBtWjWmS7R",
    tags: ["afrobeat", "pop", "tropical"],
    available: true,
    price: "250€",
    copyright: "GAIL LLEYTON BEATS © ALL RIGHTS RESERVED – COPYRIGHTS"
  },
  {
    id: 2,
    title: "PROJET X",
    genre: "Pop / Tropical / Afrobeat",
    bpm: 89,
    key: "D minor",
    duration: "3:45",
    cover: "/media/projet-x-cover.png",
    audioFile: "/media/beats/projet-x.mp3",
    audioUrl: "https://soundcloud.com/gaillleyton/projet-x-demo/s-bhQk62w6tKi",
    tags: ["pop", "tropical", "afrobeat"],
    available: true,
    price: "250€",
    copyright: "GAIL LLEYTON BEATS © ALL RIGHTS RESERVED – COPYRIGHTS"
  },
  {
    id: 3,
    title: "STAY WITH ME",
    genre: "Afro / Kompa / Caribbean",
    bpm: 85,
    key: "C# major",
    duration: "3:12",
    cover: "/media/stay-with-me-cover.png",
    audioFile: "/media/beats/stay-with-me.mp3",
    audioUrl: "https://soundcloud.com/gaillleyton/staywithme-demo/s-VE2M0L4Iy34",
    tags: ["afro", "kompa", "caribbean"],
    available: true,
    price: "250€",
    copyright: "GAIL LLEYTON BEATS © ALL RIGHTS RESERVED – COPYRIGHTS"
  },
  {
    id: 4,
    title: "BÍSÓ NA BÍSÓ",
    genre: "Afrobeat / Pop / Tropical",
    bpm: 135,
    key: "C# minor",
    duration: "3:33",
    cover: "/media/biso-na-biso-cover.png",
    audioFile: "/media/beats/biso-na-biso.mp3",
    audioUrl: "https://soundcloud.com/gaillleyton/bisonabiso-demo/s-jaj5cOjE7xC",
    tags: ["afrobeat", "pop", "tropical"],
    available: true,
    price: "250€",
    copyright: "GAIL LLEYTON BEATS © ALL RIGHTS RESERVED – COPYRIGHTS"
  },
  {
    id: 5,
    title: "QUAND TU WYNES LÀ",
    genre: "Dancehall / Tropical / Pop",
    bpm: 88,
    key: "A minor",
    duration: "2:58",
    cover: "/media/quand-tu-wynes-cover.png",
    audioFile: "/media/beats/quand-tu-wynes-la.mp3",
    audioUrl: "https://soundcloud.com/gaillleyton/quandtuwynesla-demo/s-21a2wtaoO4U",
    tags: ["dancehall", "tropical", "pop"],
    available: true,
    price: "250€",
    copyright: "GAIL LLEYTON BEATS © ALL RIGHTS RESERVED – COPYRIGHTS"
  },
  {
    id: 6,
    title: "J'VEUX QUE CA BEUZZZ",
    genre: "Trap / Rap / Urbain",
    bpm: 130,
    key: "G minor",
    duration: "3:20",
    cover: "/media/jveux-que-ca-beuzzz-cover.png",
    audioFile: "/media/beats/jveux-que-ca-beuzzz.mp3",
    audioUrl: "https://soundcloud.com/gaillleyton/jveuxquecabeuzzz-demo/s-aDtYFM9xTk4",
    tags: ["trap", "rap", "urbain"],
    available: true,
    price: "250€",
    copyright: "GAIL LLEYTON BEATS © ALL RIGHTS RESERVED – COPYRIGHTS"
  }
];

export const videos = [
  {
    id: 1,
    title: "Gail Lleyton - Crazy [Official Video]",
    type: "Clip Officiel",
    thumbnail: "https://img.youtube.com/vi/J4UTuohIlyg/maxresdefault.jpg",
    videoUrl: "https://youtu.be/J4UTuohIlyg",
    year: 2017
  },
  {
    id: 2,
    title: "Stony - Projecteurs (Official Video)",
    type: "Clip Officiel",
    thumbnail: "https://img.youtube.com/vi/f1Lbnp4gY-c/maxresdefault.jpg",
    videoUrl: "https://www.youtube.com/watch?v=f1Lbnp4gY-c",
    year: 2025
  },
  {
    id: 3,
    title: "Yoan Feat. Marvin - Mon Frère (Clip Officiel)",
    type: "Clip Officiel",
    thumbnail: "https://img.youtube.com/vi/j1LFgp7pFMQ/maxresdefault.jpg",
    videoUrl: "https://www.youtube.com/watch?v=j1LFgp7pFMQ",
    year: 2016
  },
  {
    id: 4,
    title: "Session Studio Beatmaking - BOOBA AURA T'IL VALIDÉ ?",
    type: "Session Studio",
    thumbnail: "https://img.youtube.com/vi/HmqPCVeSxbs/maxresdefault.jpg",
    videoUrl: "https://youtu.be/HmqPCVeSxbs",
    year: 2020
  },
  {
    id: 5,
    title: "Session Studio Beatmaking - C COMPLIQUÉ! VÉGÉDREAM OU DADJU ?",
    type: "Session Studio",
    thumbnail: "https://img.youtube.com/vi/cETUAORaM_U/maxresdefault.jpg",
    videoUrl: "https://youtu.be/cETUAORaM_U",
    year: 2020
  },
  {
    id: 6,
    title: "ITW pour infos - DES FEMMES DANS LE BEATMAKING, Y'EN A PAS BEAUCOUP !",
    type: "Interview",
    thumbnail: "https://img.youtube.com/vi/2DpEPCDdYy8/maxresdefault.jpg",
    videoUrl: "https://youtu.be/2DpEPCDdYy8",
    year: 2020
  }
];

export const services = [
  {
    id: 1,
    slug: "beats-production",
    title: "Beats & Production Musicale",
    shortTitle: "Beats & Production",
    description: "Compositions personnalisées et beats exclusifs pour vos projets musicaux.",
    icon: "Music",
    image: "/media/beats-production.jpg",
    fullDescription: "Je compose des instrumentales sur mesure et produis vos projets musicaux de A à Z. Chaque beat est unique et créé selon vos besoins artistiques.",
    features: [
      "Composition originale en format Wav",
      "Piste par piste inclus",
      "Œuvre inédite (exclusivité)",
      "Livraison instantanée",
      "Dépôt en Sacem",
      "Révisions incluses",
      "Support technique"
    ],
    pricing: [
      {
        name: "Beat Exclusif",
        price: "À partir de 250€",
        features: [
          "Composition originale Wav",
          "Piste par piste inclus",
          "Exclusivité du titre",
          "Livraison instantanée",
          "Dépôt en Sacem"
        ],
        popular: true
      },
      {
        name: "Coaching en Studio",
        price: "1200€",
        features: [
          "Session coaching : Jusqu'à 4 heures en studio avec Gail Lleyton",
          "Mix & Master professionnels inclus",
          "Exclusivité du titre + direction artistique",
          "Livraison sous 3 Jours ouvrés minimum + suivi sécurisé",
          "Dépôt SACEM du projet finalisé"
        ]
      },
      {
        name: "Accompagnement 2 jours à distance",
        price: "350€",
        features: [
          "Pilotage artistique personnalisé",
          "Écoute et feedback à chaque étape",
          "Conseils créatifs sur mesure",
          "Assistance technique et musicale",
          "Suivi pour finalisation"
        ]
      },
      {
        name: "Ma voix en chœurs sur ton titre",
        price: "250€",
        features: [
          "Écoute personnalisée de ton titre",
          "Enregistrement piste par piste de mes chœurs",
          "Harmonisation vocale sur mesure",
          "Nettoyage des voix + livraison en stems WAV",
          "Cession de droits étendue (usage commercial)"
        ]
      }
    ],
    popular: true
  },
  {
    id: 2,
    slug: "conseils",
    title: "Conseils Personnalisés",
    shortTitle: "Conseils Personnalisés",
    description: "Accompagnement professionnel pour faire progresser votre projet musical.",
    icon: "Lightbulb",
    image: "/media/mastering.jpg",
    fullDescription: "Bénéficiez de mon expertise pour améliorer votre musique, votre stratégie artistique et votre développement de carrière.",
    features: [
      "Call ou envoi de projet",
      "Retour personnalisé (1-3 jours)",
      "Coaching à distance",
      "Direction artistique",
      "Analyse détaillée",
      "Plan d'action concret"
    ],
    pricing: [
      {
        name: "Session Découverte",
        price: "À partir de 40€",
        features: [
          "15 à 30 minutes de call",
          "Écoute attentive de ton morceau",
          "Analyse rapide",
          "Conseils/avis artistiques ciblés",
          "Créneau call fixé selon disponibilités"
        ]
      },
      {
        name: "Retour Personnalisé",
        price: "À partir de 60€",
        features: [
          "Visio call 15–30 min + Retour par mail détaillé",
          "Écoute attentive de ton morceau",
          "Analyse récapitulatif livrée sous 72h ouvrés minimum (par mail)",
          "Conseils artistiques ciblés pour améliorer ton projet",
          "Créneau call fixé selon disponibilités"
        ]
      },
      {
        name: "Coaching à distance",
        price: "150€",
        features: [
          "Jusqu'à 2h d'accompagnement personnalisé",
          "Écoute active et échanges en temps réel",
          "Conseils ciblés pour faire avancer ton titre",
          "Direction artistique globale sur ton projet",
          "Suivi en proximité, à ton rythme et selon tes besoins"
        ],
        popular: true
      },
      {
        name: "Accompagnement 2 jours à distance",
        price: "350€",
        features: [
          "Pilotage artistique personnalisé",
          "Écoute et feedback à chaque étape",
          "Conseils créatifs sur mesure",
          "Assistance technique et musicale",
          "Suivi jusqu'à la finalisation"
        ]
      },
      {
        name: "Options possibles (sur devis)",
        price: "Variable",
        features: [
          "Besoin de plus d'heures ou de jours pour un accompagnement ? Aucun souci ! On peut planifier une extension du délai (coût supplémentaire à envisager)",
          "Je te fais les chœurs sur ton titre (description : dans Beats & Production Musicale)",
          "Projet ou livraison express"
        ]
      }
    ]
  },
  {
    id: 3,
    slug: "mixage-mastering",
    title: "Mixage & Mastering",
    shortTitle: "Mixage & Mastering",
    description: "Services professionnels de mixage et mastering audio de haute qualité.",
    icon: "Radio",
    image: "/media/mixage.jpg",
    fullDescription: "Donnez à votre musique un son professionnel avec mes services de mixage et mastering. Travail précis et soigné pour sublimer vos productions.",
    features: [
      "Ingénieur du son inclus",
      "Mix et/ou Master",
      "Métadonnée ISRC",
      "Livraison instantanée",
      "Révisions incluses",
      "Formats multiples"
    ],
    pricing: [
      {
        name: "Mixage",
        price: "150€",
        features: [
          "Mixage professionnel",
          "2 révisions incluses",
          "Délai : 72h ouvrés minimum",
          "Format Wav HD"
        ]
      },
      {
        name: "Mastering",
        price: "100€",
        features: [
          "Mastering professionnel",
          "Code ISRC",
          "Formats streaming",
          "Délai : 72h ouvrés minimum"
        ]
      },
      {
        name: "Mix + Master",
        price: "220€",
        features: [
          "Mixage complet",
          "Mastering inclus",
          "2 révisions possibles",
          "Support premium"
        ],
        popular: true
      },
      {
        name: "Options possibles (sur devis)",
        price: "Variable",
        features: [
          "Livraison express",
          "Révisions supplémentaires",
          "Je te fais les chœurs sur ton titre (description : dans Beats & Production Musicale)",
          "Demandes particulières"
        ]
      }
    ]
  },
  {
    id: 4,
    slug: "visuel-infographie",
    title: "Visuel & Infographie",
    shortTitle: "Visuel & Infographie",
    description: "Création d'identité visuelle: logo, cover, flyer, retouche photo et plus.",
    icon: "Camera",
    image: "/media/visuel-infographie.png",
    fullDescription: "Créez une identité visuelle forte et cohérente pour votre projet musical. Du logo à la pochette d'album, je donne vie à votre univers artistique.",
    features: [
      "Shooting photo",
      "Design de pochette/cover",
      "Logo et animation 3D",
      "Retouche professionnelle",
      "Flyers et affiches",
      "Identité visuelle complète"
    ],
    pricing: [
      {
        name: "Shooting photo",
        price: "300€",
        features: [
          "Pour de beaux clichés de présentation",
          "Séance photo avec 2 tenues",
          "2 photos retouchées + 10 photos en HD (format .raw)",
          "Shooting possible en intérieur ou en extérieur, à définir selon le projet",
          "Livraison sous 3 jours ouvrés minimum"
        ],
        popular: true
      },
      {
        name: "Retouche photo",
        price: "À partir de 15€",
        features: [
          "Retouche possible sur 1 photos que tu possèdes déjà",
          "Pré-requis : photo prise en HD",
          "1 photo retouchée en format .jpeg ou .png",
          "Livraison 3 jours ouvrés minimum",
          "Pour autres formats nous contacter au préalable !"
        ]
      },
      {
        name: "Cover Single/Album (Pochette Simple)",
        price: "À partir de 50€",
        features: [
          "1 à 2 propositions design de cover/pochette",
          "1 révision incluse",
          "Formats compatibles réseaux sociaux",
          "Livraison 3 jours ouvrés minimum",
          "Format de fichier à la demande (en jpeg ou png)"
        ]
      },
      {
        name: "Visuel flyer",
        price: "25€",
        features: [
          "Démarque toi pour faire parler de ton événement à venir !",
          "Tu as déjà des photos de présentation",
          "Réalisation d'un visuel flyer",
          "1 révision incluse",
          "Format de fichier à la demande (en pdf, jpeg ou png)"
        ]
      },
      {
        name: "Carte de visite - Identité Visuelle",
        price: "À partir de 30€",
        features: [
          "Design carte de visite",
          "1 révision incluse",
          "Impression non incluse",
          "Format de fichier à la demande (en pdf, jpeg ou png)"
        ]
      },
      {
        name: "Pack Premium Shooting photo + contenu vidéo",
        price: "1500€",
        features: [
          "1. Shooting photo qui contient :",
          "2h de séance photo",
          "Intérieur ou extérieur, selon le projet",
          "10 photos HD au choix (format .RAW)",
          "2 photos retouchées incluses",
          "1 visuel final pour cover single ou album",
          "+ 2. Contenu vidéo qui contient :",
          "1 Visualizer ou 1 contenu vidéo (teaser, capsule, storytelling)",
          "Direction artistique et montage inclus",
          "Livraison en HD, format adapté aux plateformes",
          "2 révisions",
          "3. Options possibles (sur devis) :",
          "Repérage et location de décor",
          "Versions alternatives du visuel (portrait, carré, bannière)",
          "Livraison express",
          "Cession de droits étendue (usage commercial, presse, etc.)"
        ]
      },
      {
        name: "Options possibles (sur devis)",
        price: "Variable",
        features: [
          "Tarif à étudier selon les besoins",
          "10 photos supplémentaires en HD (format .raw)",
          "Livraison express",
          "Révisions supplémentaires",
          "Retouches photo supplémentaires",
          "Fichier photoshop selon possibilité",
          "Autres formats visuels",
          "Versions alternatives du visuel (portrait, carré, bannière)",
          "Design de Logo personnalisé",
          "La dimension 3D à l'honneur : Logo en 3D",
          "Animation Logo 3D",
          "Personnalise tes vidéos et tes réseaux sociaux :",
          "Habillage YouTube",
          "Habillage Réseaux sociaux FB ou Twitter",
          "Habillage vidéo",
          "Pub Google Ads",
          "Autre demandes particulières",
          "Cession de droits étendue (usage commercial, presse, etc.)"
        ]
      }
    ]
  },
  {
    id: 5,
    slug: "montage-video",
    title: "Montage & Vidéo",
    shortTitle: "Montage & Vidéo",
    description: "Montage et production vidéo pour clips, teasers et contenus créatifs.",
    icon: "Sparkles",
    image: "/media/montage-video.jpg",
    fullDescription: "Donnez vie à vos projets visuels avec des montages professionnels et créatifs. Du clip musical au contenu pour réseaux sociaux.",
    features: [
      "Montage professionnel",
      "Effets et transitions",
      "Étalonnage couleur",
      "Livraison rapide",
      "Formats optimisés",
      "Motion design"
    ],
    pricing: [
      {
        name: "Visuel vidéo",
        price: "À partir de 800€",
        features: [
          "Contenu vidéo, Visualizer ou Clip vidéo",
          "Direction artistique selon l'univers musical",
          "Montage professionnel (rythme, transitions, effets)",
          "Habillage graphique : titrage, textures visuelles",
          "Étalonnage",
          "2 révisions",
          "Livraison en HD (format adapté aux plateformes)",
          "Livraison 72h ouvrées minimum"
        ]
      },
      {
        name: "Pack Premium Shooting photo + contenu vidéo",
        price: "1500€",
        features: [
          "1. Shooting photo qui contient :",
          "2h de séance photo",
          "Intérieur ou extérieur, selon le projet",
          "10 photos HD au choix (format .RAW)",
          "2 photos retouchées incluses",
          "1 visuel final pour cover single ou album",
          "+ 2. Contenu vidéo qui contient :",
          "1 Visualizer ou 1 contenu vidéo (teaser, capsule, storytelling)",
          "Direction artistique et montage inclus",
          "Livraison en HD, format adapté aux plateformes",
          "2 révisions",
          "3. Options possibles (sur devis) :",
          "Repérage et location de décor",
          "Versions alternatives du visuel (portrait, carré, bannière)",
          "Livraison express",
          "Cession de droits étendue (usage commercial, presse, etc.)"
        ],
        popular: true
      },
      {
        name: "Options possibles (sur devis)",
        price: "Variable",
        features: [
          "1) Tarif à étudier selon les besoins",
          "Animation Logo 3D",
          "Repérage et location de décor",
          "Shooting et retouches photo",
          "Versions alternatives du visuel (portrait, carré, bannière)",
          "Livraison express",
          "Cession de droits étendue (usage commercial, presse, etc.)",
          "Photos supplémentaires en HD (format .raw)",
          "Révisions supplémentaires",
          "Retouches photo supplémentaires",
          "Fichier photoshop selon possibilité",
          "Autres formats visuels",
          "Design de Logo personnalisé",
          "2) Personnalise tes vidéos et tes réseaux sociaux :",
          "Habillage YouTube",
          "Habillage Réseaux sociaux FB ou Twitter",
          "Habillage vidéo",
          "Pub Google Ads",
          "Autre demandes particulières",
          "Cession de droits étendue (usage commercial, presse, etc.)"
        ]
      }
    ]
  },
  {
    id: 6,
    slug: "site-web-vitrine",
    title: "Site Web vitrine",
    shortTitle: "Site Web vitrine",
    description: "Création de site vitrine en ligne pour votre projet.",
    icon: "Briefcase",
    image: "/media/site-web.png",
    fullDescription: "Développez votre présence en ligne avec un site web professionnel adapté à vos besoins. Design moderne, responsive et optimisé.",
    features: [
      "Design sur mesure",
      "Responsive mobile",
      "Performance optimisée",
      "Hébergement inclus",
      "Formation incluse",
      "Support technique"
    ],
    pricing: [
      {
        name: "WordPress en ligne",
        price: "À partir de 40€",
        features: [
          "Interface WordPress mise en ligne",
          "Pré-requis : Tu as déjà ton hébergement et ton nom de domaine",
          "Mise en ligne du WordPress en FTP si besoin",
          "Tarif à étudier (selon le projet)"
        ]
      },
      {
        name: "Site Vitrine",
        price: "À partir de 150€",
        features: [
          "Design personnalisé sur WordPress ou en site statique",
          "3 à 5 pages",
          "Design responsive",
          "Lien vers réseaux sociaux",
          "Pré-requis : 1 hébergement et 1 nom de domaine (non inclus)",
          "Éléments à fournir : Photos personnalisées de présentation + visuels vidéos",
          "Pour les artistes : références de titres audio déjà en ligne à fournir",
          "Tarif à étudier (selon le projet)"
        ],
        popular: true
      },
      {
        name: "Options possibles (sur devis)",
        price: "Variable",
        features: [
          "Correction d'un dossier ou bug site vitrine sur WordPress via FTP (débogage …)",
          "Correction simple d'un dossier via FTP",
          "Création d'1 hébergement + 1 nom de domaine sur une plateforme d'hébergement (OVH, LWS ou autres...)",
          "+ de 5 pages sur le site vitrine"
        ]
      }
    ]
  }
];

export const shopInfo = {
  title: "Boutique",
  description: "Explorez mes beats, services personnalisés et merchandising exclusif.",
  categories: [
    {
      id: 1,
      name: "Beats & Instrumentales",
      description: "Beats exclusifs avec licensing professionnel",
      icon: "Music2",
      link: "#beats"
    },
    {
      id: 2,
      name: "Services Créatifs",
      description: "Production, mixage, conseils personnalisés",
      icon: "Briefcase",
      link: "#services"
    },
    {
      id: 3,
      name: "Merchandising Exclusif",
      description: "Vêtements et accessoires exclusifs",
      icon: "ShoppingBag",
      link: "https://shop.GailLleyton.com"
    }
  ],
  externalShopUrl: "https://shop.gailleyton.com"
};

export const legacy = {
  title: "G.Lley' Legacy",
  description: "G.Lley' Legacy retrace les productions et collaborations signées par Gail Lleyton, également connue sous le nom de G.Lley', son alias de beatmaker et productrice, sous son label G.Lley' Lab Sound. À travers son label indépendant G.Lley' Lab Sound, qu'elle a fondé pour incarner sa vision, elle a façonné un univers sonore singulier, reflet de son identité artistique, de son innovation musicale et de sa volonté de transmission.",
  logo: "/media/glley-lab-sound-logo.png",
  url: "https://glleylabsoundrecords.com",
  ctaText: "Visiter le site G.Lley' Lab Sound",
  highlights: [
    "Label Indépendant",
    "Productions",
    "Artistes produits",
    "Collaborations"
  ]
};

export const legalInfo = {
  mentionsLegales: "/mentions-legales",
  politiqueConfidentialite: "/politique-confidentialite",
  contact: "contact@GailLleyton.com"
};
